import type { HTMLAttributes, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { AssistantAvatar } from "./assistantAvatar.tsx";
import { useAssistant } from "../../config/assistantProfile.ts";
import styles from "./emptyState.module.scss";

export interface EmptyStateProps extends HTMLAttributes<HTMLDivElement> {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  /** Secondary "Ask Issa" affordance — opens Issa with the given prompt pre-filled. */
  askIssa?: { prompt: string; label?: string };
}

export function EmptyState({ icon, title, description, action, askIssa, className, ...props }: EmptyStateProps) {
  const cls = [styles.emptyState, className ?? ""].filter(Boolean).join(" ");
  const navigate = useNavigate();
  const assistant = useAssistant();
  return (
    <div className={cls} {...props}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <h3 className={styles.title}>{title}</h3>
      {description && <p className={styles.description}>{description}</p>}
      {(action || askIssa) && (
        <div className={styles.actions}>
          {action}
          {askIssa && (
            <button
              type="button"
              className={styles.askIssaBtn}
              onClick={() => navigate("/page/issainsights", { state: { prompt: askIssa.prompt } })}
            >
              <AssistantAvatar size={18} />
              {askIssa.label ?? `Ask ${assistant.name}`}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
